__turbopack_context__.v({
  "container": "Digest-module-scss-module__sItP7a__container",
  "containerWarehouse": "Digest-module-scss-module__sItP7a__containerWarehouse",
  "content": "Digest-module-scss-module__sItP7a__content",
  "description": "Digest-module-scss-module__sItP7a__description",
  "header": "Digest-module-scss-module__sItP7a__header",
  "headerText": "Digest-module-scss-module__sItP7a__headerText",
  "link": "Digest-module-scss-module__sItP7a__link",
  "secondaryContent": "Digest-module-scss-module__sItP7a__secondaryContent",
  "section": "Digest-module-scss-module__sItP7a__section",
  "subTitle": "Digest-module-scss-module__sItP7a__subTitle",
  "title": "Digest-module-scss-module__sItP7a__title",
  "topContainer": "Digest-module-scss-module__sItP7a__topContainer",
});
